import { SET_PRINT_FONT_SIZE_PREFERENCE, PERSIST_PRINT_FONT_SIZE_PREFERENCE } from '@instructure/quiz-common';
export function setPrintFontSizePreference(fontSizePreference) {
  return {
    type: SET_PRINT_FONT_SIZE_PREFERENCE,
    fontSizePreference: fontSizePreference
  };
}
export function persistPrintFontSizePreference(fontSizePreference) {
  return {
    type: PERSIST_PRINT_FONT_SIZE_PREFERENCE,
    fontSizePreference: fontSizePreference
  };
}